import { addDays } from "date-fns";
const useSearcherActivitiesDefaultValues = (props)=>{
    const { destination , passengers , startDate , endDate  } = props ?? {};
    const { ageAtTravelTimeLabel =''  } = props?.config?.literals ?? {};
    const passengersValue = {
        adults: {
            min: 1,
            max: 9,
            value: passengers?.length ?? 1,
            selectedOptions: passengers ?? [
                30
            ],
            options: [
                ...new Array(100)
            ].map((_, index)=>({
                    label: index.toString(),
                    value: index,
                    selected: index === 30
                })),
            optionsLabel: ageAtTravelTimeLabel
        }
    };
    const dateValues = [
        addDays(new Date(), 7),
        addDays(new Date(), 10)
    ];
    return {
        destination: destination,
        calendar: startDate && endDate ? [
            new Date(startDate),
            new Date(endDate)
        ] : dateValues,
        passengers: passengersValue
    };
};
export default useSearcherActivitiesDefaultValues;

//# sourceMappingURL=useSearcherActivitiesDefaultValues.js.map